/* HER-01 Hero · STARKFELD UI-Library (24.09.2026). Markup: snippets/sf-hero.liquid
   1. Trustpilot: lädt das TrustBox-Widget. Die Trustpilot-App bringt das
      Bootstrap-Skript auf Produktseiten schon mit; fehlt es, wird es einmal
      nachgeladen. Ein Widget, das schon ein iframe hat, bleibt unberührt.
   2. Video: startet stumm per Skript (nicht bei "Bewegung reduzieren"), hält
      außerhalb des Bildschirms an, Pause-Knopf (WCAG 2.2.2).
   3. Button-Sprung: Zeigt der Link auf eine Sprungmarke, die es auf der Seite
      nicht gibt (z. B. #buybox), geht es zum Kaufbereich main-product. */
(function () {
  'use strict';
  if (window.__sfHero) return;
  window.__sfHero = true;

  var BOOT = 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
  var reduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var reduced = function () { return !!(reduce && reduce.matches); };

  function tpLoad(box) {
    if (box.querySelector('iframe')) return;
    if (window.Trustpilot && typeof window.Trustpilot.loadFromElement === 'function') {
      window.Trustpilot.loadFromElement(box);
    }
  }
  function initTrustpilot() {
    var boxes = [].slice.call(document.querySelectorAll('[data-sfh-tp]'));
    if (!boxes.length) return;
    if (window.Trustpilot) { boxes.forEach(tpLoad); return; }
    if (!document.querySelector('script[src*="tp.widget.bootstrap"]')) {
      var s = document.createElement('script');
      s.src = BOOT;
      s.async = true;
      document.head.appendChild(s);
    }
    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      if (window.Trustpilot || tries > 75) {
        clearInterval(timer);
        boxes.forEach(tpLoad);
      }
    }, 200);
  }

  function initVideo(root) {
    var video = root.querySelector('[data-sfh-video]');
    if (!video || video.__sfh) return;
    video.__sfh = true;
    var btn = root.querySelector('[data-sfh-vbtn]');
    var userPaused = reduced();
    var visible = false;

    function mark(paused) {
      root.classList.toggle('is-paused', paused);
      if (btn) btn.setAttribute('aria-label', paused ? 'Video abspielen' : 'Video anhalten');
    }
    function play() {
      var p = video.play();
      mark(false);
      if (p && typeof p.catch === 'function') p.catch(function () { mark(true); });
    }
    function pause() { video.pause(); mark(true); }

    if (userPaused) mark(true);
    if (btn) {
      btn.addEventListener('click', function () {
        if (video.paused) { userPaused = false; play(); } else { userPaused = true; pause(); }
      });
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          visible = e.isIntersecting;
          if (userPaused) return;
          if (visible) play(); else video.pause();
        });
      }, { threshold: 0.1 }).observe(video);
    } else if (!userPaused) {
      play();
    }
  }

  /* 4. Sticky-Kaufleiste (main-product): verborgen, solange der Hero mit
        seinem eigenen Kaufbutton den oberen Bildschirmteil füllt (Unterkante
        unter 40 % der Höhe). So liegt sie nie über dem Hero, und es gibt
        trotzdem immer einen Kaufweg. */
  function initSticky(root) {
    if (root.__sfhSticky || !('IntersectionObserver' in window)) return;
    if (!document.querySelector('product-sticky-form')) return;
    root.__sfhSticky = true;
    var html = document.documentElement;
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { html.classList.toggle('sfh-in-view', e.isIntersecting); });
    }, { rootMargin: '-40% 0px -59% 0px' }).observe(root);
  }

  function jumpTarget() {
    var el = document.querySelector('[data-sf-main-product]');
    if (el) return el;
    var form = document.querySelector('main form[action*="/cart/add"], form[action*="/cart/add"]');
    return form ? (form.closest('.shopify-section') || form) : null;
  }
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('[data-sfh-cta]') : null;
    if (!a) return;
    var href = a.getAttribute('href') || '';
    if (href.charAt(0) !== '#' || href.length < 2) return;
    if (document.getElementById(href.slice(1))) return;
    var target = jumpTarget();
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: reduced() ? 'auto' : 'smooth', block: 'start' });
  });

  function init(scope) {
    initTrustpilot();
    var heroes = (scope || document).querySelectorAll('[data-sf-hero]');
    [].forEach.call(heroes, initVideo);
    if (heroes.length) initSticky(heroes[0]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
